var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIconVisit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1494_202187",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.179199,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1494_202187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3 10.4791L9.61667 8.16245C9.75 8.02912 9.91111 7.96245 10.1 7.96245C10.2889 7.96245 10.45 8.02912 10.5833 8.16245C10.7167 8.29578 10.7833 8.4569 10.7833 8.64578C10.7833 8.83467 10.7167 8.99578 10.5833 9.12912L7.76667 11.9458C7.63333 12.0791 7.47778 12.1458 7.3 12.1458C7.12222 12.1458 6.96667 12.0791 6.83333 11.9458L5.41667 10.5291C5.28333 10.3958 5.21667 10.2347 5.21667 10.0458C5.21667 9.8569 5.28333 9.69578 5.41667 9.56245C5.55 9.42912 5.71111 9.36245 5.9 9.36245C6.08889 9.36245 6.25 9.42912 6.38333 9.56245L7.3 10.4791ZM3.33333 14.8458C2.96667 14.8458 2.65278 14.7152 2.39167 14.4541C2.13056 14.193 2 13.8791 2 13.5125V4.17912C2 3.81245 2.13056 3.49856 2.39167 3.23745C2.65278 2.97634 2.96667 2.84578 3.33333 2.84578H4V2.17912C4 1.99023 4.06389 1.8319 4.19167 1.70412C4.31944 1.57634 4.47778 1.51245 4.66667 1.51245C4.85556 1.51245 5.01389 1.57634 5.14167 1.70412C5.26944 1.8319 5.33333 1.99023 5.33333 2.17912V2.84578H10.6667V2.17912C10.6667 1.99023 10.7306 1.8319 10.8583 1.70412C10.9861 1.57634 11.1444 1.51245 11.3333 1.51245C11.5222 1.51245 11.6806 1.57634 11.8083 1.70412C11.9361 1.8319 12 1.99023 12 2.17912V2.84578H12.6667C13.0333 2.84578 13.3472 2.97634 13.6083 3.23745C13.8694 3.49856 14 3.81245 14 4.17912V13.5125C14 13.8791 13.8694 14.193 13.6083 14.4541C13.3472 14.7152 13.0333 14.8458 12.6667 14.8458H3.33333ZM3.33333 13.5125H12.6667V6.84578H3.33333V13.5125ZM3.33333 5.51245H12.6667V4.17912H3.33333V5.51245Z",
    fill: "#9E9E9E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconVisit);
export default __webpack_public_path__ + "static/media/profile-icon-visit.a13178093499b69549aff9925454eeed.svg";
export { ForwardRef as ReactComponent };